import Fooji from "@fooji/microsites";

export const saveCode = async (code: string) => {
  await Fooji.UserSettings.save({
    lc_cod_code: code,
    entry_token: code,
    file_upload: false,
    lc_cod_order_id: false,
    lc_cod_order_date: false,
    lc_cod_location_id: false
  });
};
